import React, { useState, useContext, useRef, useEffect } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import { getImages } from '../Const';
import { LeadsContext } from '../Context/LeadsContext';
const MAX_FILES = 30;
const MAX_FILE_SIZE_MB = 32;

const DropZoneBox = ({leadId,showUpload,documentData}) => {
  const {uploadDocument} = useContext(LeadsContext);

  const [previews, setPreviews] = useState([]); 

  const formikRef = useRef(null);

  const [selectedImages, setSelectedImages] = useState([]);
  const handleImageChange = (event, setFieldValue) => {
      const files = Array.from(event.target.files);

      const newImages = files.map(file => URL.createObjectURL(file));
      setSelectedImages(prevImages => [...prevImages, ...newImages]);
      //setFieldValue('photos', event.target.files);

      uploadFiles(event.target.files);
  };

  const handleDrop = (event, setFieldValue) => {
      event.preventDefault();
      const files = Array.from(event.dataTransfer.files);
      const newImages = files.map(file => URL.createObjectURL(file));
      setSelectedImages(prevImages => [...prevImages, ...newImages]);
      //setFieldValue('photos', event.dataTransfer.files);

      uploadFiles(event.dataTransfer.files);
  };

  const uploadFiles = (files) => {
      Array.from(files).map((v, i) => {
          uploadFile(v);
      });
  }

  const uploadFile = (file) => {

      const fileSizeMB = file.size / (1024 * 1024);

      console.log(file);

      if (file && file.type.startsWith('application/pdf') && fileSizeMB <= MAX_FILE_SIZE_MB) {

          const formData = new FormData();
          formData.append('file', file);
          formData.append('folder', 'appraisals/lead'+leadId+'/');
          formData.append('fileName', file.name);
          //formData.append('base_url',true);

          const upload = uploadDocument(formData);
          upload.then((data) => {
              if (data.url && data.data && data.data.key) {

                  formikRef.current.setFieldValue("files", [...formikRef.current.values.files, data.url]);

                  console.log(formikRef.current.values);

                  setPreviews([...previews, {"name":file.name,"url":data.url}]);

              } else if (data.error) alert(data.error);
          });
      }

  }

  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleRemoveImage = (indexToRemove) => {
    setPreviews(prev => prev.filter((_, i) => i !== indexToRemove));
    formikRef.current.setFieldValue('files', formikRef.current.values.files.filter((_, i) => i !== indexToRemove));
  };  

  useEffect(() => {
    console.log("lead id changed",leadId,documentData);
    //getDocuments(leadId);

    if(documentData) {

      const docs = documentData.filter((v) => !v.headers['content-type'].includes('image'));

      formikRef.current.setFieldValue("files", docs.map((v,i) => {return v.url}));

      console.log(formikRef.current.values);

      setPreviews(docs.map((v,i) => { return {"name":v.name,"url":v.url}}));

    }
  },[leadId,documentData]);
  
  return (
    <>
      <Formik
        initialValues={{ files: [] }}
        innerRef={formikRef}
        onSubmit={(values) => {
          console.log(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <FieldArray type="hidden" name="files" value={values.files} />
            {showUpload && <div className='drop-zone-box adq-zone-box pt-3 pb-3'
                onDrop={(e) => handleDrop(e, setFieldValue)}
                onDragOver={handleDragOver}>
              <div
                className="drop-zone text-uppercase text-center"
              >
                <div className='mb-2 text-dblue xs-title'>Upload <br />Documents</div>
                <div className='mb-3 text-center'>
                  <img src={getImages('icon-upload.png')} />
                </div>
              </div>
              <div className='mb-3 text-gray font-13 text-center'>Drag and Drop files or</div>
              <div className='text-center'>
                <div className='blue-btn adq-upload-btn text-uppercase position-relative fw-700'>
                  <label htmlFor="fileInput">
                    <span>Browse</span>
                  </label>
                  <input
                    type="file"
                    accept="application/pdf"
                    multiple
                    onChange={(e) => handleImageChange(e, setFieldValue)}
                    id="fileInput"
                  />
                </div>
              </div>
            </div>}
              {previews.length > 0 && (
                <div className='preview-container mt-3'>
                  {previews.map((preview, index) => {
                    const cleanName = preview.name
                      ?.replace(/\.[^/.]+$/, '')
                      .replace(/[_-]+/g, ' ')
                      .replace(/\b\w/g, char => char.toUpperCase());

                    return (
                      <div key={index} className="d-flex align-items-center justify-content-between mb-2">
                        <div className='two-line-ellipsis' style={{ fontSize: '12px', marginTop: '4px' }}>{cleanName}</div>
                        <div className="d-flex justify-content-center gap-2 mt-2">
                          <a
                            href={preview.url}
                            download={preview.name}
                            className="btn-transparent-btn"
                            target="_blank"
                          >
                            <img src={getImages('download-icon1.svg')}/>
                          </a>
                          <button
                            type="button"
                            className="btn-transparent-btn"
                            onClick={() => handleRemoveImage(index)}
                          >
                            <img src={getImages('delete-icon1.svg')}/>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default DropZoneBox;
